/**
 * Vista: detalle de una Orden de Producción (AMX-PR-FR-01).
 *
 * La pantalla es, sobre todo, los BOTONES: arrancar, detener, reanudar, terminar.
 * Sólo se pintan los que la orden admite en su estado — el servidor los valida
 * igual, así que esto es comodidad, no seguridad.
 *
 * Y la parte que de verdad importa para la métrica: al detener SE EXIGE el
 * motivo. Un paro sin motivo mide el tiempo perdido pero no explica nada, y sin
 * la explicación la métrica no sirve para arreglar la línea.
 */

import ordenProduccionService from '../services/ordenProduccion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

const ETIQUETA_ESTADO = {
  abierta: 'Abierta', en_proceso: 'En proceso', pausada: 'Detenida',
  terminada: 'Terminada', cancelada: 'Cancelada',
};
const COLOR_ESTADO = {
  abierta: 'var(--info, #2c5c7a)', en_proceso: 'var(--primary, #1f5a7a)',
  pausada: 'var(--warning, #96601a)', terminada: 'var(--success, #2e6b4f)',
  cancelada: 'var(--text-muted, #75868c)',
};

function esc(s) {
  return String(s === null || s === undefined ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function horas(h) {
  const n = Number(h);
  if (!isFinite(n) || n < 0) return '—';
  return n < 24 ? `${n} h` : `${Math.floor(n / 24)} d ${n % 24} h`;
}
function fecha(f) {
  if (!f) return '—';
  const d = new Date(f);
  return isNaN(d) ? '—' : d.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
}
function soloFecha(f) {
  if (!f) return '—';
  const d = new Date(f);
  return isNaN(d) ? '—' : d.toLocaleDateString('es-MX', { dateStyle: 'medium' });
}

export default {
  async render() {
    return `
      <div id="opDetalle">
        <div class="card"><div style="padding:2rem;text-align:center;">Cargando orden...</div></div>
      </div>

      <div id="opModalAutoriza" style="display:none;position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:1000;
           align-items:center;justify-content:center;padding:1rem;">
        <div class="card" style="max-width:480px;width:100%;margin:0;">
          <div class="card-header"><h3 class="card-title">Pedir autorización al jefe de producción</h3></div>
          <form id="opFormAutoriza">
            <div class="form-group">
              <label class="form-label">¿Qué se pide autorizar?</label>
              <select name="tipo" class="form-input">
                ${ordenProduccionService.TIPOS_AUTORIZACION.map(t => `<option value="${t.valor}">${t.texto}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Dilo en palabras <span style="color:var(--danger,#a33)">*</span></label>
              <input type="text" name="descripcion" class="form-input" maxlength="500" required
                     placeholder="Ej: cambiar la bomba hidráulica, no viene en el alcance">
            </div>
            <label style="display:flex;gap:.5rem;align-items:flex-start;font-size:.9rem;margin-bottom:1rem;">
              <input type="checkbox" name="pausar" checked style="margin-top:.2rem;">
              <span>Detener la orden mientras se autoriza.
                <span style="color:var(--text-muted);display:block;">
                  Déjalo marcado si no se puede seguir sin el permiso: así el tiempo de espera
                  queda medido solo. Desmárcalo para horas extra, donde el trabajo sigue.
                </span>
              </span>
            </label>
            <div style="display:flex;gap:.75rem;justify-content:flex-end;">
              <button type="button" class="btn btn-secondary" onclick="window.opDetalleView.cerrarAutoriza()">Cancelar</button>
              <button type="submit" class="btn btn-primary">Pedir autorización</button>
            </div>
          </form>
        </div>
      </div>

      <div id="opModalPausa" style="display:none;position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:1000;
           align-items:center;justify-content:center;padding:1rem;">
        <div class="card" style="max-width:460px;width:100%;margin:0;">
          <div class="card-header"><h3 class="card-title">Detener la orden</h3></div>
          <form id="opFormPausa">
            <p style="color:var(--text-muted);font-size:.9rem;margin-top:0;">
              El motivo es obligatorio: es lo que después explica en qué se va el tiempo.
            </p>
            <div class="form-group">
              <label class="form-label">Motivo <span style="color:var(--danger,#a33)">*</span></label>
              <select name="motivo" class="form-input" required>
                ${ordenProduccionService.MOTIVOS_PAUSA.map(m => `<option value="${m.valor}">${m.texto}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Detalle</label>
              <input type="text" name="detalle" class="form-input" maxlength="255"
                     placeholder="Ej: esperando filtro de aceite">
            </div>
            <div style="display:flex;gap:.75rem;justify-content:flex-end;margin-top:1rem;">
              <button type="button" class="btn btn-secondary" onclick="window.opDetalleView.cerrarPausa()">Cancelar</button>
              <button type="submit" class="btn btn-primary">Detener</button>
            </div>
          </form>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    if (!permisos.canView('ordenes_produccion')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else {
        document.getElementById('content').innerHTML =
          '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2></div></div>';
      }
      return;
    }
    window.opDetalleView = this;
    this.id = (params && params.id) || (location.pathname.split('/').pop());
    document.getElementById('opFormPausa').addEventListener('submit', (e) => this.pausar(e));
    document.getElementById('opFormAutoriza').addEventListener('submit', (e) => this.solicitarAutorizacion(e));
    await this.cargar();
  },

  async cargar() {
    try {
      const r = await ordenProduccionService.obtener(this.id);
      this.orden = r.data || r;
      // Van en la misma carga para que la tarjeta no parpadee vacía. Si fallara,
      // la orden se pinta igual: las autorizaciones son un añadido, no el plato.
      try {
        const a = await ordenProduccionService.autorizaciones(this.id);
        this.autorizaciones = a.data || a || [];
      } catch (_) { this.autorizaciones = []; }
      this.pintar();
    } catch (e) {
      document.getElementById('opDetalle').innerHTML = `
        <div class="card"><div style="padding:2rem;text-align:center;">
          <h3>No se encontró la orden</h3>
          <button class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-produccion')">Volver al listado</button>
        </div></div>`;
    }
  },

  botones() {
    const o = this.orden;
    if (!permisos.canEdit('ordenes_produccion')) return '';
    const acciones = ordenProduccionService.accionesDe(o.estado);
    const b = [];
    if (acciones.includes('iniciar')) {
      b.push(`<button class="btn btn-primary" onclick="window.opDetalleView.iniciar()">▶ Arrancar trabajo</button>`);
    }
    if (acciones.includes('pausar')) {
      b.push(`<button class="btn btn-secondary" onclick="window.opDetalleView.abrirPausa()">⏸ Detener</button>`);
    }
    if (acciones.includes('reanudar')) {
      b.push(`<button class="btn btn-primary" onclick="window.opDetalleView.reanudar()">▶ Reanudar</button>`);
    }
    if (acciones.includes('terminar')) {
      b.push(`<button class="btn btn-success" onclick="window.opDetalleView.terminar()">✓ Terminar</button>`);
    }
    // Se puede pedir autorización mientras la orden siga viva. No depende del estado:
    // el caso más común es justo pedirla ANTES de arrancar.
    if (!['terminada', 'cancelada'].includes(o.estado)) {
      b.push(`<button class="btn btn-secondary" onclick="window.opDetalleView.abrirAutoriza()">🖊 Pedir autorización</button>`);
    }
    if (acciones.includes('cancelar') && permisos.can('ordenes_produccion', 'cancelar')) {
      b.push(`<button class="btn btn-danger" onclick="window.opDetalleView.cancelar()">Cancelar orden</button>`);
    }
    return b.join(' ');
  },

  pintar() {
    const o = this.orden;
    const pausas = o.pausas_detalle || [];
    const textoMotivo = Object.fromEntries(ordenProduccionService.MOTIVOS_PAUSA.map(m => [m.valor, m.texto]));
    const abierta = pausas.find(p => !p.fin);

    document.getElementById('opDetalle').innerHTML = `
      <div class="card">
        <div class="card-header" style="display:flex;justify-content:space-between;align-items:center;gap:1rem;flex-wrap:wrap;">
          <div>
            <h2 class="card-title" style="margin-bottom:.2rem;">
              ${esc(o.folio)}
              <span style="display:inline-block;padding:2px 10px;border-radius:10px;font-size:.72rem;font-weight:600;
                    color:#fff;background:${COLOR_ESTADO[o.estado]};vertical-align:middle;margin-left:.4rem;">
                ${ETIQUETA_ESTADO[o.estado] || o.estado}
              </span>
            </h2>
            <div style="color:var(--text-muted);font-size:.9rem;">
              <span style="font-family:monospace;">${esc(o.num_serie)}</span>
              ${o.modelo ? ' · ' + esc(o.modelo) : ''} · ${esc(o.tipo)} · prioridad ${esc(o.prioridad)}
            </div>
          </div>
          <div style="display:flex;gap:.5rem;flex-wrap:wrap;">
            ${this.botones()}
            <button class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-produccion')">Volver</button>
          </div>
        </div>

        ${abierta ? `
          <div style="background:var(--warning-bg, #f8ecd8);border-left:4px solid ${COLOR_ESTADO.pausada};
                padding:.8rem 1rem;border-radius:6px;margin-bottom:1.25rem;">
            <strong>Detenida desde ${fecha(abierta.inicio)}</strong> —
            ${esc(textoMotivo[abierta.motivo] || abierta.motivo)}${abierta.detalle ? ': ' + esc(abierta.detalle) : ''}
            · lleva ${horas(abierta.horas)}
          </div>` : ''}

        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:1rem;margin-bottom:1.5rem;">
          <div style="background:var(--bg-secondary);padding:1rem;border-radius:8px;text-align:center;">
            <div style="font-size:1.4rem;font-weight:bold;">${o.fecha_inicio_real ? horas(o.horas_efectivas) : '—'}</div>
            <div style="color:var(--text-muted);font-size:.85rem;">Trabajadas</div>
          </div>
          <div style="background:var(--bg-secondary);padding:1rem;border-radius:8px;text-align:center;">
            <div style="font-size:1.4rem;font-weight:bold;color:${Number(o.horas_detenida) > 0 ? COLOR_ESTADO.pausada : 'inherit'};">
              ${Number(o.horas_detenida) > 0 ? horas(o.horas_detenida) : '—'}</div>
            <div style="color:var(--text-muted);font-size:.85rem;">Detenida (${o.pausas || 0} paros)</div>
          </div>
          <div style="background:var(--bg-secondary);padding:1rem;border-radius:8px;text-align:center;">
            <div style="font-size:1.4rem;font-weight:bold;">${o.dias_para_arrancar != null ? o.dias_para_arrancar + ' d' : '—'}</div>
            <div style="color:var(--text-muted);font-size:.85rem;">Tardó en arrancar</div>
          </div>
          <div style="background:var(--bg-secondary);padding:1rem;border-radius:8px;text-align:center;">
            <div style="font-size:1.4rem;font-weight:bold;color:${o.dias_de_retraso ? 'var(--danger,#a33)' : 'inherit'};">
              ${o.dias_de_retraso ? o.dias_de_retraso + ' d' : '—'}</div>
            <div style="color:var(--text-muted);font-size:.85rem;">Retraso vs. plan</div>
          </div>
        </div>

        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:1.25rem;">
          <div>
            <h4 style="margin:0 0 .5rem;">Trabajo</h4>
            <p style="margin:0 0 .5rem;color:var(--text-muted);">${esc(o.descripcion || 'Sin descripción')}</p>
            <div style="font-size:.9rem;">
              <div><strong>Línea:</strong> ${esc(o.linea || '—')}</div>
              <div><strong>Técnico:</strong> ${esc(o.tecnico || '—')}</div>
              <div><strong>Responsable:</strong> ${esc(o.responsable || '—')}</div>
              <div><strong>Solicitó:</strong> ${esc(o.solicitada_por || '—')}</div>
            </div>
          </div>
          <div>
            <h4 style="margin:0 0 .5rem;">Fechas</h4>
            <div style="font-size:.9rem;">
              <div><strong>Solicitud:</strong> ${soloFecha(o.fecha_solicitud)}</div>
              <div><strong>Inicio planeado:</strong> ${soloFecha(o.fecha_inicio_plan)}</div>
              <div><strong>Fin planeado:</strong> ${soloFecha(o.fecha_fin_plan)}</div>
              <div><strong>Arrancó:</strong> ${fecha(o.fecha_inicio_real)}</div>
              <div><strong>Terminó:</strong> ${fecha(o.fecha_fin_real)}</div>
              ${o.motivo_cancelacion ? `<div style="color:var(--danger,#a33);"><strong>Cancelada:</strong> ${esc(o.motivo_cancelacion)}</div>` : ''}
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header"><h3 class="card-title">Paros de esta orden</h3></div>
        ${pausas.length ? `
          <div class="table-container">
            <table class="table">
              <thead><tr><th>Motivo</th><th class="tbl-hide-mobile">Detalle</th><th>Desde</th><th>Hasta</th><th>Duró</th></tr></thead>
              <tbody>
                ${pausas.map(p => `
                  <tr>
                    <td>${esc(textoMotivo[p.motivo] || p.motivo)}</td>
                    <td class="tbl-hide-mobile">${esc(p.detalle || '')}</td>
                    <td>${fecha(p.inicio)}</td>
                    <td>${p.fin ? fecha(p.fin) : '<em style="color:' + COLOR_ESTADO.pausada + '">sigue detenida</em>'}</td>
                    <td>${horas(p.horas)}</td>
                  </tr>`).join('')}
              </tbody>
            </table>
          </div>` : `
          <p style="color:var(--text-muted);padding:.5rem 0;">
            Esta orden no se ha detenido ni una vez.
          </p>`}
      </div>
    
      <div class="card">
        <div class="card-header"><h3 class="card-title">Autorizaciones del jefe de producción</h3></div>
        ${this.tarjetaAutorizaciones()}
      </div>
`;
  },

  // ── Autorizaciones ────────────────────────────────────────────────────────

  /**
   * Se pinta el tiempo que lleva esperando cada una, no sólo quién firmó: eso es
   * lo que el cliente pidió medir. En rojo a partir de un día, porque una orden
   * parada 24 h esperando una firma es justamente el cuello de botella que se busca.
   */
  tarjetaAutorizaciones() {
    const lista = this.autorizaciones || [];
    if (!lista.length) {
      return `<p style="color:var(--text-muted);padding:.5rem 0;">
        A esta orden no se le ha pedido ninguna autorización.
      </p>`;
    }
    const texto = Object.fromEntries(
      ordenProduccionService.TIPOS_AUTORIZACION.map(t => [t.valor, t.texto]));
    const color = { pendiente: COLOR_ESTADO.pausada, autorizada: COLOR_ESTADO.terminada,
                    rechazada: 'var(--danger,#a33)' };
    const puedeResolver = permisos.canEdit('ordenes_produccion');

    return `
      <div class="table-container">
        <table class="table">
          <thead><tr>
            <th>Qué</th><th class="tbl-hide-mobile">Pidió</th><th>Estado</th>
            <th>Esperó</th><th></th>
          </tr></thead>
          <tbody>
            ${lista.map(a => {
              const tardanza = Number(a.horas_de_espera);
              const alarma = isFinite(tardanza) && tardanza >= 24;
              return `
              <tr>
                <td>
                  <strong>${esc(texto[a.tipo] || a.tipo)}</strong>
                  <div style="color:var(--text-muted);font-size:.85rem;">${esc(a.descripcion)}</div>
                  ${a.motivo_rechazo ? `<div style="color:var(--danger,#a33);font-size:.85rem;">
                      Rechazada: ${esc(a.motivo_rechazo)}</div>` : ''}
                </td>
                <td class="tbl-hide-mobile">
                  ${esc(a.solicitada_por || '—')}
                  <div style="color:var(--text-muted);font-size:.85rem;">${fecha(a.solicitada_at)}</div>
                </td>
                <td>
                  <span style="display:inline-block;padding:2px 10px;border-radius:10px;font-size:.72rem;
                        font-weight:600;color:#fff;background:${color[a.estado]};">
                    ${a.estado === 'pendiente' ? 'Pendiente' : a.estado === 'autorizada' ? 'Autorizada' : 'Rechazada'}
                  </span>
                  ${a.resuelta_por ? `<div style="color:var(--text-muted);font-size:.85rem;">
                      ${esc(a.resuelta_por)}</div>` : ''}
                </td>
                <td style="${alarma ? 'color:var(--danger,#a33);font-weight:600;' : ''}">
                  ${horas(a.horas_de_espera)}${a.sigue_esperando ? ' <em style="font-weight:400;">y contando</em>' : ''}
                </td>
                <td style="white-space:nowrap;">
                  ${a.estado === 'pendiente' && puedeResolver ? `
                    <button class="btn btn-success btn-sm" onclick="window.opDetalleView.autorizar(${a.id})">Autorizar</button>
                    <button class="btn btn-danger btn-sm" onclick="window.opDetalleView.rechazar(${a.id})">Rechazar</button>
                  ` : ''}
                </td>
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>`;
  },

  abrirAutoriza() { document.getElementById('opModalAutoriza').style.display = 'flex'; },
  cerrarAutoriza() {
    document.getElementById('opModalAutoriza').style.display = 'none';
    document.getElementById('opFormAutoriza').reset();
  },

  async solicitarAutorizacion(ev) {
    ev.preventDefault();
    const fd = new FormData(ev.target);
    const data = {
      tipo: fd.get('tipo'),
      descripcion: String(fd.get('descripcion') || '').trim(),
      pausar: fd.get('pausar') === 'on',
    };
    this.cerrarAutoriza();
    await this._accion(
      () => ordenProduccionService.solicitarAutorizacion(this.id, data),
      'Autorización pedida al jefe de producción');
  },

  autorizar(autId) {
    const nota = prompt('¿Alguna nota para quien la pidió? (opcional)');
    if (nota === null) return;
    const data = { estado: 'autorizada' };
    if (nota.trim()) data.nota = nota.trim();
    this._accion(() => ordenProduccionService.resolverAutorizacion(autId, data), 'Autorizada');
  },

  rechazar(autId) {
    // El motivo se exige aquí y también en el servidor: un rechazo mudo deja la orden
    // detenida sin que nadie sepa qué arreglar para volver a pedirla.
    const motivo = prompt('¿Por qué se rechaza? El motivo es obligatorio.');
    if (motivo === null) return;
    if (!motivo.trim()) {
      if (window.toast) toast.error('Hay que decir por qué se rechaza');
      return;
    }
    this._accion(
      () => ordenProduccionService.resolverAutorizacion(autId, {
        estado: 'rechazada', motivo_rechazo: motivo.trim(),
      }), 'Rechazada');
  },

  // ── Acciones ──────────────────────────────────────────────────────────────

  async _accion(fn, mensajeOk) {
    try {
      await fn();
      if (window.toast) toast.success(mensajeOk);
      await this.cargar();
    } catch (e) {
      // El servidor manda el porqué cuando la transición no es legal; se muestra
      // tal cual en vez de un "ocurrió un error" que no ayuda a nadie.
      if (window.toast) toast.error(e.message || 'No se pudo completar la acción');
      console.error(e);
    }
  },

  iniciar() {
    this._accion(() => ordenProduccionService.iniciar(this.id), 'Trabajo arrancado');
  },

  reanudar() {
    this._accion(() => ordenProduccionService.reanudar(this.id), 'Orden reanudada');
  },

  terminar() {
    if (!confirm('¿Terminar esta orden? Después ya no se puede reabrir.')) return;
    this._accion(() => ordenProduccionService.terminar(this.id), 'Orden terminada');
  },

  cancelar() {
    const motivo = prompt('¿Por qué se cancela la orden?');
    if (motivo === null) return;
    if (!motivo.trim()) {
      if (window.toast) toast.error('El motivo de cancelación es obligatorio');
      return;
    }
    this._accion(() => ordenProduccionService.cancelar(this.id, { motivo: motivo.trim() }), 'Orden cancelada');
  },

  abrirPausa() { document.getElementById('opModalPausa').style.display = 'flex'; },
  cerrarPausa() {
    document.getElementById('opModalPausa').style.display = 'none';
    document.getElementById('opFormPausa').reset();
  },

  async pausar(ev) {
    ev.preventDefault();
    const fd = new FormData(ev.target);
    const data = { motivo: fd.get('motivo') };
    const detalle = String(fd.get('detalle') || '').trim();
    if (detalle) data.detalle = detalle;
    this.cerrarPausa();
    await this._accion(() => ordenProduccionService.pausar(this.id, data), 'Orden detenida');
  },
};
